import {
  initialState,
  Actions,
  State,
  UPDATE_GROUP_MAIN_CURRENCY,
  UPDATE_GROUP_MAIN_CURRENCY_SUCCESS,
  UPDATE_GROUP_MAIN_CURRENCY_ERROR,
  RESET_UPDATE_GROUP_MAIN_CURRENCY,
} from "../../types/group/update-group-main-currency";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_GROUP_MAIN_CURRENCY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case UPDATE_GROUP_MAIN_CURRENCY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case UPDATE_GROUP_MAIN_CURRENCY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_UPDATE_GROUP_MAIN_CURRENCY:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
